import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";

export default function AuthError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Auto-redirect to login after 5 seconds
    const timer = setTimeout(() => {
      navigate("/login");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  const errorMessage =
    searchParams.get("error") ||
    "An unknown error occurred during authentication.";

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center max-w-md mx-auto">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <div className="text-red-600 text-6xl mb-4">❌</div>
          <h1 className="text-2xl font-semibold text-red-800 mb-4">
            Authentication Failed
          </h1>
          <p className="text-red-600 mb-6">{errorMessage}</p>
          <div className="space-y-3">
            <button
              onClick={() => navigate("/login")}
              className="w-full bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors"
            >
              Back to Login
            </button>
            <p className="text-sm text-gray-500">
              You will be automatically redirected to the login page in 5
              seconds.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
